import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

export const baseUrlInterceptor: (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
) => Observable<HttpEvent<any>> = (req, next) => {
  const apiUrl = environment.apiUrl;

  // Obtener la zona horaria del navegador
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let updatedReq = req;
  updatedReq = updatedReq.clone({
    headers: req.headers.set('x-timezone', timezone),
    timeout: 30 * 1000,
  });

  if (!req.url.startsWith('http')) {
    updatedReq = updatedReq.clone({
      url: `${apiUrl}${req.url.startsWith('/') ? '' : '/'}${req.url}`,
    });
  }
  return next(updatedReq);
};
